<div class="m-2 bg-danger">
    <h3>An error occurred.</h3>

    <p>{{errorDescription}}</p>
</div>